module.exports = __webpack_public_path__ + "static/Crowns 1 intraoral before-07ff8a4426c00633e1efa086695afe63.jpg";